import { render, staticRenderFns } from "./ListPageDesktop.vue?vue&type=template&id=d311edac"
import script from "./ListPageDesktop.vue?vue&type=script&lang=js"
export * from "./ListPageDesktop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports